<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td Дата начала нетрудоспособности
        td
          span(v-if='data.body.content.start_date') {{data.body.content.start_date | date}}
          span(v-if='!data.body.content.start_date') —
      tr
        td Дата окончания нетрудоспособности
        td
          span(v-if='data.body.content.end_date') {{data.body.content.end_date | date}}
          span(v-if='!data.body.content.end_date') —
      tr
        td Тип ЛВН
        td {{formatAnswer(data.body.content.incapacity_certificate_type, 3)}}
      tr
        td Вид ЛВН
        td {{formatAnswer(data.body.content.incapacity_certificate_kind, 3)}}
      tr
        td Причина нетрудоспособности
        td {{formatAnswer(data.body.content.incapacity_reason, 3)}}
      tr
        td Дополнительные коды нетрудоспособности
        td {{formatAnswer(data.body.content.incapacity_circumstance, 3)}}
      tr
        td Режим
        td(v-if="data.body.content.treatment_mode && data.body.content.treatment_mode.length")
          span(v-for="mode in data.body.content.treatment_mode")
            div {{mode.name}}
        td(v-if="!data.body.content.treatment_mode") —
      tr
        td Нарушение режима
        td {{formatAnswer(data.body.content.is_treatment_mode_violated, 1)}}
      tr
        td Число дней нетрудоспособности
        td {{formatAnswer(data.body.content.incapacity_days, 2)}}
      tr
        td Исход
        td {{formatAnswer(data.body.content.incapacity_outcome, 3)}}
      tr
        td Предварительный диагноз
        td {{formatAnswer(data.body.content.preliminary_diagnosis, 4)}}
      tr
        td Заключительный диагноз
        td {{formatAnswer(data.body.content.final_diagnosis, 4)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
        case 4:
          return fact ? fact.code + ' ' + fact.diagnosis_text : '—'

      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
